export const initState = {
	$currencyList: [],

	price: '',
	currency1: null,
	currency2: null,

	data: {
		currency1: null,
		currency2: null,
		price: 0,
		$result: 0,
		_result: 'init',
	},
};

export default initState;
